export default "__VITE_ASSET__DnUaeaIc__"